import { style } from '@vanilla-extract/css';
import { themeVars } from '@customerio/pluma-components/css/theme-tokens';

export const salesforceInfoCard = style(
  {
    backgroundColor: themeVars.color['surface-subtle'],
    padding: 46,
    borderRadius: themeVars.radius['4'],
  },
  'salesforce-info-card',
);
